interface MyigusWishlistModalContentProps {
  content: string;
}

export const MyigusWishlistModalContent = ({ content }: MyigusWishlistModalContentProps) => <p>{content}</p>;
